import {
  Box, Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { pxToRem } from "../../utils/editor.ts";
import React, { useEffect, useState } from "react";
import useOutlineStore from "../../stores/modules/outline.ts";
import { PaperService } from "../../services/paperService.ts";
import { Document, Page, pdfjs } from "react-pdf";
import ToggleSwitch from "./Switch.tsx";

interface PdfReviewModalProps {
  isPaperViewerOpen: boolean
  onPaperViewerClose: (isOpen: boolean) => void,
  paperId: string,
  sectionNode?: any
}

export const LatexReviewModal: React.FC<PdfReviewModalProps> = ({
                                                                isPaperViewerOpen,
                                                                onPaperViewerClose,
                                                                paperId,
                                                                sectionNode
                                                              }) => {
  const [content, setContent] = useState('')
  const { currentSectionIndex, outline } = useOutlineStore()
  
  // 配置pdfjs worker
  pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@4.8.69/build/pdf.worker.min.mjs`;
  
  // PDF文档选项，支持中文字符
  const pdfOptions = {
    cMapUrl: `//unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
    cMapPacked: true,
  };
  
  const [err, setError] = useState('')
  const [numPages, setNumPages] = useState<number | null>(null);

  const compileSectionPdf = async (mode: 'single' | 'double') => {
    if (!outline?.nodes?.length && !sectionNode) return
    setContent('')
    const section = sectionNode || outline.nodes[currentSectionIndex]
    try {
      const res = await PaperService.compilePdf({
        sectionNode: section,
        paperStyle: mode,
        paperId
      })
      if (res?.compile_message) {
        setError(res?.compile_message)
        return
      }
      previewPDF(res.base64_pdf_string)
    } catch (err) {
      setError(err?.response?.data?.compile_message)
      console.error('Failed to compile PDF:', err)
    }
  }
  useEffect(() => {
    if (!isPaperViewerOpen) return
    compileSectionPdf('single')
  }, [isPaperViewerOpen]) // 添加依赖

  function previewPDF(base64Data: string) {
    const base64String = base64Data.startsWith('data:application/pdf;base64,')
      ? base64Data.split(',')[1]
      : base64Data;

    const binaryString = atob(base64String);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    // 创建Blob对象
    const blob = new Blob([bytes], { type: 'application/pdf' });

    const pdfUrl = URL.createObjectURL(blob);
    setContent(pdfUrl)
  }

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
  };

  return (
    <Modal size={'lg'} isOpen={isPaperViewerOpen} onClose={() => onPaperViewerClose(false)}>
      <ModalOverlay/>
      <ModalContent width={'100%'} maxW={'800px'} height={'80%'}>
        <ModalHeader style={{ display: 'flex', alignItems: 'center' }}>
          <Box>Preview PDF</Box>
          <ToggleSwitch onChange={(mode) => {
            compileSectionPdf(mode)
          }}/>
        </ModalHeader>
        <ModalCloseButton _focusVisible={{ boxShadow: 'none' }}
                          bg={'#FFFFFF'}
                          width={pxToRem(24)}
                          height={pxToRem(24)}
                          _hover={{ bg: '#D3D7E2' }}
                          color={'#8E9ABC'}
                          top={pxToRem(20)}
                          right={pxToRem(20)}
                          fontSize={'8px'}
                          borderRadius={'50%'}/>
        <ModalBody width={'full'} height={'80%'}>
          <Box w={'100%'} h={'100%'}
               sx={{
                 ".react-pdf__Document": {
                   overflowY: 'auto',
                   overflowX: 'hidden',
                   height: '100%',
                   width: '100%',
                 },
                 ".react-pdf__Page": {
                   width: '100%',
                   marginBottom: '1rem'
                 },
                 canvas: {
                   width: '98%!important',
                   border: '2px solid #D3D7E2',
                   borderRadius: pxToRem(24)
                 }
               }}>
            {err ? (
              <Box whiteSpace="pre-wrap" h="full" overflowY={'auto'}>{err}</Box>
            ) : content ? (
              <Document
                file={content}
                options={pdfOptions}
                onLoadSuccess={onDocumentLoadSuccess}
                onLoadError={(error) => console.error('Error loading PDF:', error)}
              >
                {Array.from(new Array(numPages), (_, index) => (
                  <Page
                    key={`page_${index + 1}`}
                    pageNumber={index + 1}
                    width={800}
                    renderTextLayer={false}
                    renderAnnotationLayer={false}
                  />
                ))}
              </Document>
            ) : (
              <Image
                mt={'40%'}
                mx={'auto'}
                w={pxToRem(60)}
                objectFit="cover"
                src="/static/loading-animate.svg"
                transform={"scale(2)"}
              />
            )}
          </Box>
        </ModalBody>

        {/*<ModalFooter>*/}
        {/*  <Button*/}
        {/*    w={pxToRem(100)}*/}
        {/*    h={'48px'}*/}
        {/*    bg={'#1D8AFF'}*/}
        {/*    _hover={{ background: '#1D8AFF', color: '#FFFFFF' }}*/}
        {/*    border={'1px solid #1D8AFF'}*/}
        {/*    borderRadius={'10px'}*/}
        {/*    color={'#FFFFFF'} mr={3}*/}
        {/*    onClick={() => onPaperViewerClose(false)}>*/}
        {/*    Confirm*/}
        {/*  </Button>*/}
        {/*</ModalFooter>*/}
      </ModalContent>
    </Modal>
  )
}